import { defineMessages } from 'react-intl';

const previewCardMessages = defineMessages({
	loadingLabel: {
		id: 'ai-mate.preview-card.loading-label',
		defaultMessage: 'Loading {label}',
		description: 'Accessible label announced by screen readers when content is being loaded',
	},
} as const);

export default previewCardMessages;
